import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import './winter-landing.css';
import HighwaysUK from './Highways-UK-Winner.jpg';
import SensorUoB from './wintersense-landscape-vibrant-wide.jpg';
import './icomoon/style.css';
import UoBLogo from './UoB-logo.png';
import CSLLogo from './CSL-logo.png';

const WinterLanding = () => (
  <div className="ws-landing">

    <Container>

      <h1 className="display-4 text-center m-3">Sense where you've never sensed before.</h1>

      <p className="text-justify">Reliable road temperature measurements are paramount to Winter Road Maintenance operations. However, sensing an entire road network with traditional technologies isn't always affordable or practical. Wintersense takes a different approach...</p>

      <Row>

        <Col xs="12" md="4">
          <div className="key-point text-center mt-2">
            <span className="key-point__icon icon-fast"></span>
            <h5 className="key-point__heading">Fast to Install</h5>
            <p className="key-point__info">Mounted in under 5 minutes.</p>
          </div>
        </Col>

        <Col xs="12" md="4">
          <div className="key-point text-center mt-2">
            <span className="key-point__icon icon-affordable"></span>
            <h5 className="key-point__heading">Affordable</h5>
            <p className="key-point__info">An order of magnitude cheaper than traditional solutions.</p>
          </div>
        </Col>

        <Col xs="12" md="4">
          <div className="key-point text-center mt-2">
            <span className="key-point__icon icon-non-invasive"></span>
            <h5 className="key-point__heading">Non-Invasive</h5>
            <p className="key-point__info">Uses infrared technology.</p>
          </div>
        </Col>                   

      </Row>


      <h1 className="display-4 text-center m-3">The power of more.</h1>

      <p className="text-justify">The ability to quickly and affordably deploy a single Wintersense sensor, or hundreds of them, virtually anywhere opens the door to a variety of use cases:</p>

      <Row>

        <Col xs="12" md="6" lg="4">
          <ul>
            <li className="apps-list__item">Ground truth for verifying route based forecasts.</li>
          </ul>
        </Col>

        <Col xs="12" md="6" lg="4">
          <ul>
            <li className="apps-list__item">Assimilate into a short-range, site specific forecast model (<span className="font-italic">nowcasting</span>).</li>
          </ul>
        </Col>

        <Col xs="12" md="6" lg="4">
          <ul>
            <li className="apps-list__item">Saturate a whole road network with sensors, enabling selective salting.</li>
          </ul>
        </Col>

        <Col xs="12" md="6" lg="4">
          <ul>
            <li className="apps-list__item">Deploy to suspected cold spots, e.g. bridge decks, frost hollows, or accident black spots.</li>
          </ul>
        </Col> 

        <Col xs="12" md="6" lg="4">
          <ul>
            <li className="apps-list__item">Inform real-time decision making.</li>
          </ul>
        </Col>

        <Col xs="12" md="6" lg="4">
          <ul>
            <li className="apps-list__item">Install at novel locations, not previously worthy of a full traditional outstation, e.g. car parks.</li>
          </ul>
        </Col>     
                               
      </Row>

      <p className="text-center mt-4 mb-0">If you're interested in deploying Wintersense sensors in your region then please don't hesitate to</p>
      <Row>
        <Col xs="12" md={{ size: 8, offset: 2 }}>
          <a className="action-button btn btn-lg mb-5 mt-1 btn-block" href="mailto:info@wintersense.com?Subject=Tell%20Me%20More" target="_top">Get In Touch</a>
        </Col>
      </Row>  


      <div className="d-flex justify-content-around align-items-center flex-wrap flex-md-nowrap">
        <div>
          <img src={UoBLogo} width="200px" className="mx-5 my-2" alt="University of Birmingham Marque" />
        </div>
        <div>
          <p className="text-justify mb-0">Wintersense has been developed by meteorologists at the <a href="http://www.birmingham.ac.uk/">University of Birmingham</a>. A department with a long history of research into winter road sensing and forecasting. We believe that the latest 21st century technology offers new opportunities to turn the way we perform Winter Road Maintenance on its head!</p>
        </div>
      </div>

      <br />
      <br />

      <div className="d-flex justify-content-around align-items-center flex-wrap flex-md-nowrap">
        <div>
          <img src={CSLLogo} width="200px" className="mx-5 my-2" alt="University of Birmingham Marque" />
        </div>
        <div>
          <p className="text-justify mb-0"><a href="https://www.campbellsci.co.uk">Campbell Scientific</a>, a leading global environmental measurement solutions provider has secured the global licensing rights for the Wintersense technology and are responsible for further developing, commercialising and deploying the technology globally.</p>
        </div>
      </div>


      <img src={HighwaysUK} alt="Intelligent Infrastructure Hub 2017 Winner" className="img-fluid my-5" />

    </Container>


    <img src={SensorUoB} alt="Wintersense sensor" className="img-fluid center-block" />

  </div>
);

export default WinterLanding;



// WEBPACK FOOTER //
// ./src/components/WinterLanding/index.js